import "../../App.css";
import "./Header.css";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { FaMap, FaCity, FaStar, FaLightbulb, FaEdit, FaStore } from "react-icons/fa";
import { directionsLink } from "../../utils/pickup";
import Header from "./Header-2";
import { FaArrowLeft } from "react-icons/fa";
import { userOrder } from '../../states/userOrder';
import Modal from "../Modal/modal";
import useWindowWidth from "../hooks/useMediaQuery";
import AddressAdd from "../Address/AddressAdd";
import { configShop } from '../../states/configShop';
import ShopAdd from "../Address/ShopAdd";
import ShopAddLocal from "../Address/ShopAddLocal";
import { useLocalStorageExpire } from "../hooks/useLocalStorageExpire";
import PopUpProgramarNew2 from "../DetallePago/PopUpProgramarNew2";
export const Header3 = (props) => {
    const { dataConfig } = configShop();
    const width = useWindowWidth()
    const { dataUser } = userOrder();
    const [abierto, setAbierto] = useState(dataConfig?.branch?.status ?? true);
    const { propiedadesCompany, configHeader } = props;
    const [listaProductosCarrito, setListaProductosCarrito] = useState();
    const [openModal, setOpenModal] = useState(false);
    const [copied, setCopied] = useState(false);
    const [openShop, setOpenShop] = useState(false);
    const [openShopLocal, setOpenShopLocal] = useState(false);
    const [popupStatus, setPopupStatus] = useLocalStorageExpire('CloseShop', true, 10);
    var totalCantidadCarrito = 0;
    useEffect(() => {
        const informacionLocalStorage = localStorage.getItem(
            "infoProductoSeleccionado"
        );
        if (
            informacionLocalStorage !== undefined &&
            informacionLocalStorage !== null
        ) {
            let parsedRespuesta = JSON.parse(informacionLocalStorage); // JSON.parse convierte la información de string a un objeto de javascript.

            setListaProductosCarrito(parsedRespuesta);
        }
    }, []);
    if (listaProductosCarrito !== undefined) {
        listaProductosCarrito.map((item) => {
            totalCantidadCarrito += item.cantidadProducto;
        });
    }
    useEffect(() => {
        if (dataUser.deliveryMethod === 2 && !dataUser?.shopData?.name) {
            setOpenShop(true);
        }
    }, [dataUser.deliveryMethod, dataUser.shopData]);

    var typeSend = localStorage.getItem("typeSend");
    return (
        <div>
            <div className="header3" style={{ backgroundImage: "url(" + dataConfig?.page_menu?.header_image + ")" }}>
                <div className="left">
                    {dataUser.deliveryMethod !== 3 ? (
                        <Link to="/">
                            <FaArrowLeft color={dataConfig?.page_menu?.button?.color ?? "#000"} size={24} />
                        </Link>
                    ) : null
                    }

                </div>
                <div className="Right">
                    <div className="col-12 text-center text-lg-end">
                        <div className="estado-calificacion d-flex flex-column align-items-end">
                            <div className={`estado ${abierto ? "abierto" : "cerrado"}`}>
                                {abierto ? (
                                    <>
                                        <FaLightbulb className="text-warning bombillo-titilando me-1" />
                                        Abierto ahora
                                    </>
                                ) : (
                                    "Cerrado por ahora"
                                )}
                            </div>
                            <div className="calificacion d-flex align-items-center mt-1">
                                <FaStar className="text-warning" />
                                <span className="ms-1">{dataConfig?.qualification}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="restaurant-info-container">
                <Header
                    properties={propiedadesCompany}
                />
                {dataUser.deliveryMethod === 1 ? (
                    <section className="container-sub-titulos" onClick={() => setOpenModal(true)}>
                        <div className="container-agregar-tarjeta" style={{ width: "100%", justifyContent: "space-between" }}>
                            <span><FaMap /> {dataUser.address},  {dataUser.city_name}</span>
                            <span>Editar <FaEdit /></span>
                        </div>
                    </section>
                ) : dataUser.deliveryMethod === 2 && dataUser.pickupOnly === true ? (
                    // PLZ-325: en "Pide y Recoge" la sede se muestra como el lugar donde se recoge.
                    <section className="container-sub-titulos">
                        <div className="container-agregar-tarjeta" style={{ width: "100%", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                <span style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "12px", color: "#666" }}><FaStore /> Recoges en</span>
                                <span style={{ fontWeight: "600" }}>{dataUser?.shopData?.name}</span>
                                <span style={{ fontSize: "12px", color: "#666" }}>{dataUser?.shopData?.address}, {dataUser?.shopData?.city}</span>
                                {directionsLink(dataUser?.shopData) && (
                                    <a href={directionsLink(dataUser?.shopData)} target="_blank" rel="noopener noreferrer" style={{ fontSize: "13px", fontWeight: 600, textDecoration: "none" }}>
                                        <FaMap /> Cómo llegar
                                    </a>
                                )}
                            </div>
                            <span style={{ cursor: "pointer" }} onClick={() => setOpenShop(true)}>Cambiar sede <FaEdit /></span>
                        </div>
                    </section>
                ) : dataUser.deliveryMethod === 2 ? (
                    <section className="container-sub-titulos" onClick={() => setOpenShop(true)}>
                        <div className="container-agregar-tarjeta" style={{ width: "100%", justifyContent: "space-between" }}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ fontWeight: "500" }}>{dataUser?.shopData?.name}</span>
                                <span style={{ fontSize: "12px", color: "#666" }}>{dataUser?.shopData?.address},{dataUser?.shopData?.city}</span>
                            </div>
                            <span>Editar <FaEdit /></span>
                        </div>
                    </section>
                ) : dataUser.deliveryMethod === 0 ? (
                    <section className="container-sub-titulos" onClick={() => setOpenShopLocal(true)}>
                        <div className="container-agregar-tarjeta" style={{ width: "100%", justifyContent: "space-between" }}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ fontWeight: "500" }}>{dataUser?.shopData?.name}</span>
                                <span style={{ fontSize: "12px", color: "#666" }}>{dataUser?.shopData?.address},{dataUser?.shopData?.city}</span>
                            </div>
                            <span>Editar <FaEdit /></span>
                        </div>
                    </section>
                ) : dataUser.deliveryMethod === 3 ? (
                    <section className="container-sub-titulos">
                        <div className="container-agregar-tarjeta" style={{ width: "100%", justifyContent: "space-between" }}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ fontWeight: "500" }}>{propiedadesCompany?.branch?.name}</span>
                                <span style={{ fontSize: "12px", color: "#666" }}>{propiedadesCompany?.branch?.address},{propiedadesCompany?.branch?.city}</span>
                            </div>
                        </div>
                    </section>
                ) : null
                }

            </div >
            <Modal
                h={"auto"}
                w={width > 768 ? "60%" : "90%"}
                isOpen={openModal}
                onClick={() => setOpenModal(false)}
                title={"Datos de entrega."}
            >
                <AddressAdd
                    setOpenModal={setOpenModal}
                />
            </Modal>
            <Modal
                h={"auto"}
                w={width > 768 ? "60%" : "90%"}
                isOpen={openShop}
                onClick={() => setOpenShop(false)}
                title={"Seleccione Tienda"}
            >
                <ShopAdd
                    setOpenModal={setOpenShop}
                />
            </Modal>
            <Modal
                h={"auto"}
                w={width > 768 ? "60%" : "90%"}
                isOpen={openShopLocal}
                onClick={() => setOpenShopLocal(false)}
                title={"Seleccione Tienda Local"}
            >
                <ShopAddLocal
                    setOpenModal={setOpenShopLocal}
                />
            </Modal>

            <Modal
                h={"auto"}
                w={width > 768 ? "60%" : "90%"}
                isOpen={popupStatus && !abierto}
                title={"Tienda Cerrada."}
                onClick={() => setPopupStatus(false)}
            >
                <PopUpProgramarNew2
                    popupStatus={popupStatus}
                    setPopupStatus={setPopupStatus}
                    propiedadesCompany={dataUser}
                    color_botton={dataConfig?.page_menu?.button?.color}
                    btnTextColor={dataConfig?.page_menu?.button?.color_text}
                />

            </Modal>



        </div >
    );
};

export default Header3;
